import { render, staticRenderFns } from "./StockRecordsDialog.vue?vue&type=template&id=4f4d6fc2&scoped=true&"
import script from "./StockRecordsDialog.vue?vue&type=script&lang=js&"
export * from "./StockRecordsDialog.vue?vue&type=script&lang=js&"
import style0 from "./StockRecordsDialog.vue?vue&type=style&index=0&id=4f4d6fc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d6fc2",
  null
  
)

export default component.exports